import { useSelector } from "react-redux";

// 지문분석 단계 표시줄 — ECHO 시안 01·02의 steps 알약
// 표시 전용 위젯: 클릭/이동 동작 없음. sectionList가 비어 있으면 렌더링하지 않는다.
// 좌우 스크롤 금지: PC는 한 줄에 다 들어가고(7개 × ~110px < 960px),
// 모바일은 현재 단계만 라벨을 펼치고 나머지는 번호 점만 보여 한 줄에 고정한다.
const STEP_LABELS = {
  keypoints: "핵심정리",
  reading: "지문읽기",
  direct_translation: "직독직해",
  words: "단어학습",
  syntax_analysis: "구문분석",
  flow: "흐름정리",
  sentence_test: "문장테스트",
};

// 지문분석 코스 고정 순서 — 출제 안 된 단계도 자리를 보여준다
const STEP_ORDER = [
  "keypoints",
  "reading",
  "direct_translation",
  "syntax_analysis",
  "sentence_test",
  "flow",
  "words",
];

const FONT =
  "'Pretendard','Spoqa Han Sans Neo','Apple SD Gothic Neo','Noto Sans KR',sans-serif";

const StepsBar = () => {
  const { sectionList, section } = useSelector((state) => state.assignment);
  const isMobile = Math.min(window.innerWidth, window.screen.width) <= 768;

  if (!sectionList || sectionList.length === 0 || !section) return null;

  return (
    <div
      style={{
        background: "#fff",
        borderBottom: "1px solid #ECF1F2",
        padding: isMobile ? "8px 10px" : "9px 16px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: isMobile ? "2px" : "5px",
        width: "100%",
        overflow: "hidden", // 스크롤바 원천 차단
        fontFamily: FONT,
        flex: "none",
      }}
    >
      {STEP_ORDER.map((type, i) => {
        // [코스 v1] 출제 여부와 무관하게 전체 7단계 자리를 표시.
        // 출제된 단계만 실제 섹션과 매칭하고, 미출제는 흐리게(비활성).
        const s = sectionList.find((sec) => sec.type === type);
        const exists = !!s;
        const isOn = exists && section && s.id === section.id;
        const isDone = exists && !isOn && s.is_finished;
        const showLabel = !isMobile || isOn;

        return (
          <span
            key={type}
            style={{
              display: "flex",
              alignItems: "center",
              gap: showLabel ? "5px" : 0,
              fontSize: "11.5px",
              fontWeight: 700,
              whiteSpace: "nowrap",
              padding: showLabel ? "6px 11px" : "6px 4px",
              borderRadius: "999px",
              color: isOn ? "#fff" : isDone ? "#00A396" : exists ? "#7A8490" : "#D3D8DD",
              backgroundColor: isOn ? "#0E141B" : "transparent",
              opacity: exists ? 1 : 0.5, // [코스 v1] 미출제 단계 흐리게
            }}
          >
            <span
              style={{
                width: "14px",
                height: "14px",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "8.5px",
                flex: "none",
                border: `1.5px solid ${isDone || isOn ? "#00D9C0" : exists ? "#B9C1C9" : "#E6EDEC"}`,
                backgroundColor: isDone ? "#00D9C0" : "transparent",
                color: isDone ? "#fff" : isOn ? "#00D9C0" : "inherit",
              }}
            >
              {isDone ? "✓" : i + 1}
            </span>
            {showLabel && (STEP_LABELS[type] || `단계 ${i + 1}`)}
          </span>
        );
      })}
    </div>
  );
};

export default StepsBar;
